import { useEffect } from 'react';

import { useEmitterContext } from '../context';

export const useSubscription = (callback) => {
    const { addConditionListener, removeConditionListener } = useEmitterContext();

    useEffect(() => {
        addConditionListener(callback);

        return () => {
            removeConditionListener(callback);
        };
    }, [callback, addConditionListener, removeConditionListener]);
};
